const TELAS = {
    CURSOS: 0,
    COLABORADORES: 1,
    TAREFAS: 2,
    TEMPLATE_TAREFAS: 3,
    LOCAIS_DE_TAREFAS: 4,
    AGENDA_RELATORIOS: 5,
    PERMISSOES: 6,
}
export default TELAS;
